import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const ContentWithoutSliderContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.marginMD}px;
  padding: ${({ theme: { token } }) => token.paddingLG + token.padding}px ${({ theme: { token } }) => token.margin}px;
  align-items: center;
  justify-content: center;
`;


